import { lazy } from 'react'

import { FacilityDetailsProvider } from 'contexts/FacilityDetailsContext'
import { Route } from 'react-router-dom'
import { FacilityConfigProvider } from 'contexts/FacilityConfigContext'
import { PermissionProvider } from 'contexts/PermissionContext'
import { AVP_SERVICE_PROCESS_INTEGRITY } from 'constants/avp_permissions'
const PSEProjectEvaluation = lazy(() => import('pages/ProcessSafetyElements/PSEProjectEvaluation'))
const PSEQuestionConfiguration = lazy(
  () => import('pages/ProcessSafetyElements/PSEQuestionConfiguration')
)
const PSESetupScore = lazy(() => import('pages/ProcessSafetyElements/PSESetupScore'))
const PSESetupStandardAction = lazy(
  () => import('pages/ProcessSafetyElements/PSESetupStandardAction')
)
const PSESetupLoadsheet = lazy(() => import('pages/ProcessSafetyElements/PSESetupLoadsheet'))
const PagePSEAuditEntryForm = lazy(() => import('pages/ProcessSafetyElements/PSEAuditEntryForm'))
const PSEDashboard = lazy(() => import('pages/ProcessSafetyElements/PSEDashboard'))

const ProcessSafetyRoutes = (
  <>
    <Route
      path="/process-safety-elements/project/:project_id/"
      element={
        <PermissionProvider serviceName={AVP_SERVICE_PROCESS_INTEGRITY}>
        <FacilityConfigProvider slug="project_feature_config">
          <FacilityDetailsProvider>
            <PSEProjectEvaluation />
          </FacilityDetailsProvider>
        </FacilityConfigProvider>
        </PermissionProvider>
      }
    />

    <Route
      path="/process-safety-elements/project/:project_id/asset/:asset_id/dashboard"
      element={
        <PermissionProvider serviceName={AVP_SERVICE_PROCESS_INTEGRITY}>
        <FacilityConfigProvider slug="project_feature_config">
          <FacilityDetailsProvider>
            <PSEDashboard />{' '}
          </FacilityDetailsProvider>
        </FacilityConfigProvider>
        </PermissionProvider>
      }
    />
    <Route
      path="/process-safety-elements/project/:project_id/asset/:asset_id/configuration"
      element={
        <PermissionProvider serviceName={AVP_SERVICE_PROCESS_INTEGRITY}>
        <FacilityConfigProvider slug="project_feature_config">
          <FacilityDetailsProvider>
            <PSEQuestionConfiguration />
          </FacilityDetailsProvider>
        </FacilityConfigProvider>
        </PermissionProvider>
      }
    />
    <Route
      path="/process-safety-elements/project/:project_id/asset/:asset_id/scores"
      element={
        <PermissionProvider serviceName={AVP_SERVICE_PROCESS_INTEGRITY}>
        <FacilityConfigProvider slug="project_feature_config">
          <FacilityDetailsProvider>
            <PSESetupScore />
          </FacilityDetailsProvider>
        </FacilityConfigProvider>
        </PermissionProvider>
      }
    />
    <Route
      path="/process-safety-elements/project/:project_id/asset/:asset_id/standard-actions"
      element={
        <PermissionProvider serviceName={AVP_SERVICE_PROCESS_INTEGRITY}>
        <FacilityConfigProvider slug="project_feature_config">
          <FacilityDetailsProvider>
            <PSESetupStandardAction />
          </FacilityDetailsProvider>
        </FacilityConfigProvider>
        </PermissionProvider>
      }
    />
    <Route
      path="/process-safety-elements/project/:project_id/asset/:asset_id/loadsheet-setup"
      element={
        <PermissionProvider serviceName={AVP_SERVICE_PROCESS_INTEGRITY}>
        <FacilityConfigProvider slug="project_feature_config">
          <FacilityDetailsProvider>
            <PSESetupLoadsheet />
          </FacilityDetailsProvider>
        </FacilityConfigProvider>
        </PermissionProvider>
      }
    />
    <Route
      path="/process-safety-elements/project/:project_id/asset/:asset_id/element/:element_id/audit-entry-form"
      element={
        <PermissionProvider serviceName={AVP_SERVICE_PROCESS_INTEGRITY}>
        <FacilityConfigProvider slug="project_feature_config">
          <FacilityDetailsProvider>
            <PagePSEAuditEntryForm />
          </FacilityDetailsProvider>
        </FacilityConfigProvider>
        </PermissionProvider>
      }
    />
  </>
)

export default ProcessSafetyRoutes
